module.exports = __webpack_public_path__ + "img/personaLogin.38831eb7.png";